export default __webpack_public_path__ + "static/image-2-6e7d231c8fd0de7d3a80a332d9591cb5.jpg";